interface IconProps {
  width?: number;
  height?: number;
  fill?: string;
}

export function CloseIcon({
  width = 16,
  height = 16,
  fill = '#5A5A5A',
}: IconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 13.3998L7.10005 18.2998C6.91672 18.4831 6.68338 18.5748 6.40005 18.5748C6.11672 18.5748 5.88338 18.4831 5.70005 18.2998C5.51672 18.1165 5.42505 17.8831 5.42505 17.5998C5.42505 17.3165 5.51672 17.0831 5.70005 16.8998L10.6 11.9998L5.70005 7.0998C5.51672 6.91647 5.42505 6.68314 5.42505 6.3998C5.42505 6.11647 5.51672 5.88314 5.70005 5.6998C5.88338 5.51647 6.11672 5.4248 6.40005 5.4248C6.68338 5.4248 6.91672 5.51647 7.10005 5.6998L12 10.5998L16.9 5.6998C17.0834 5.51647 17.3167 5.4248 17.6 5.4248C17.8834 5.4248 18.1167 5.51647 18.3 5.6998C18.4834 5.88314 18.575 6.11647 18.575 6.3998C18.575 6.68314 18.4834 6.91647 18.3 7.0998L13.4 11.9998L18.3 16.8998C18.4834 17.0831 18.575 17.3165 18.575 17.5998C18.575 17.8831 18.4834 18.1165 18.3 18.2998C18.1167 18.4831 17.8834 18.5748 17.6 18.5748C17.3167 18.5748 17.0834 18.4831 16.9 18.2998L12 13.3998Z"
        fill={fill}
      />
    </svg>
  );
}

export function MicrophoneIcon({
  width = 24,
  height = 24,
  fill = '#5A5A5A',
}: IconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 14C11.1666 14 10.4583 13.7083 9.87495 13.125C9.29162 12.5417 8.99995 11.8333 8.99995 11V5C8.99995 4.16667 9.29162 3.45833 9.87495 2.875C10.4583 2.29167 11.1666 2 12 2C12.8333 2 13.5416 2.29167 14.125 2.875C14.7083 3.45833 15 4.16667 15 5V11C15 11.8333 14.7083 12.5417 14.125 13.125C13.5416 13.7083 12.8333 14 12 14ZM11 20V17.925C9.46662 17.7083 8.15412 17.0583 7.06245 15.975C5.97079 14.8917 5.30829 13.575 5.07495 12.025C5.04162 11.7417 5.11662 11.5 5.29995 11.3C5.48329 11.1 5.71662 11 5.99995 11C6.28329 11 6.52079 11.0958 6.71245 11.2875C6.90412 11.4792 7.03329 11.7167 7.09995 12C7.33329 13.1667 7.91245 14.125 8.83745 14.875C9.76245 15.625 10.8166 16 12 16C13.2 16 14.2583 15.6208 15.175 14.8625C16.0916 14.1042 16.6666 13.15 16.9 12C16.9666 11.7167 17.0958 11.4792 17.2875 11.2875C17.4791 11.0958 17.7166 11 18 11C18.2833 11 18.5166 11.1 18.7 11.3C18.8833 11.5 18.9583 11.7417 18.925 12.025C18.6916 13.5417 18.0333 14.85 16.95 15.95C15.8666 17.05 14.55 17.7083 13 17.925V20C13 20.2833 12.9041 20.5208 12.7125 20.7125C12.5208 20.9042 12.2833 21 12 21C11.7166 21 11.4791 20.9042 11.2875 20.7125C11.0958 20.5208 11 20.2833 11 20ZM12 12C12.2833 12 12.5208 11.9042 12.7125 11.7125C12.9041 11.5208 13 11.2833 13 11V5C13 4.71667 12.9041 4.47917 12.7125 4.2875C12.5208 4.09583 12.2833 4 12 4C11.7166 4 11.4791 4.09583 11.2875 4.2875C11.0958 4.47917 11 4.71667 11 5V11C11 11.2833 11.0958 11.5208 11.2875 11.7125C11.4791 11.9042 11.7166 12 12 12Z"
        fill={fill}
      />
    </svg>
  );
}

export function TrashIcon({
  width = 20,
  height = 20,
  fill = '#ef4444',
}: IconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z"
        fill={fill}
      />
    </svg>
  );
}
